function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 1.66699H15V6.66699L11.6667 10.0003L12.8092 11.1429C12.2838 11.2713 11.791 11.4826 11.3454 11.7624L10 10.417L6.66667 13.7503V16.667H9.04407C9.12335 17.262 9.30728 17.8239 9.57674 18.3337H5V13.3337L8.33333 10.0003L5 6.66699V1.66699ZM13.3333 6.25033V3.33366H6.66667V6.25033L10 9.58366L13.3333 6.25033Z",
  fill: "#FF4106"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5 13.7503C13.5 13.2901 13.8358 13.0003 14.25 13.0003C14.6642 13.0003 15 13.2901 15 13.7503L15 16.2694C15 16.7296 14.6642 17.0003 14.25 17.0003C13.8358 17.0003 13.5 16.7296 13.5 16.2694L13.5 13.7503Z",
  fill: "#FF4106"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5 18.7587C13.5 18.2984 13.8358 18.0003 14.25 18.0003C14.6642 18.0003 15 18.2984 15 18.7587C15 19.2189 14.6642 19.5003 14.25 19.5003C13.8358 19.5003 13.5 19.2189 13.5 18.7587Z",
  fill: "#FF4106"
});

var SvgExpired = function SvgExpired(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExpired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Expired.4cd1f201.svg";
export { ForwardRef as ReactComponent };